import { HeaderButton } from "@omni/components/components/Navigation/Buttons/HeaderButton/headerButton";
import { HeaderButtonBaseProps } from "@omni/components/components/Navigation/Buttons/HeaderButton/headerButton.base";
import { cn } from "@omni/utils/styles";
import { ReactElement } from "react";

type Props = Omit<HeaderButtonBaseProps, "menuElement"> & {
    children?: ReactElement<{ closeCallback?: () => void }> | false | null;
};

export const HeaderButtonComponent = ({
    icon,
    text,
    alerts,
    ariaLabel,
    hover,
    invert,
    link,
    textHidden,
    hideChevron,
    iconPrefix,
    invertMobile,
    withOverlay,
    className,
    children
}: Props) => {
    return (
        <HeaderButton
            icon={icon}
            text={text}
            alerts={alerts}
            ariaLabel={ariaLabel}
            hover={hover}
            invert={invert}
            link={link}
            textHidden={textHidden}
            hideChevron={hideChevron}
            iconPrefix={iconPrefix}
            invertMobile={invertMobile}
            withOverlay={withOverlay}
            className={className}
            menuElement={children}
        >
            <HeaderButton.Trigger>
                <HeaderButton.Trigger.Icon>
                    <HeaderButton.Trigger.Icon.Alerts
                        className={cn("tw:text-white tw:bg-secondary")}
                    />
                </HeaderButton.Trigger.Icon>
                <HeaderButton.Trigger.Content />
                <HeaderButton.Trigger.Chevron />
            </HeaderButton.Trigger>
            <HeaderButton.Menu
                className={cn(
                    "tw:bg-background tw:shadow-outline",
                    "tw:lg:rounded-xl"
                )}
            />
        </HeaderButton>
    );
};
